function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "php_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "php_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#php_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "php-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "php-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#php_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.6474 26.4875C42.7656 37.0121 33.5654 45 22.5 45C14.163 45 6.885 40.466 2.99848 33.7289C2.04979 32.086 1.30412 30.3126 0.793477 28.4418C0.275537 26.5491 0 24.5562 0 22.5C0 10.0736 10.0736 0 22.5 0C32.7563 0 41.4091 6.86206 44.1192 16.2459C44.6924 18.2314 45 20.3299 45 22.5C45 23.861 44.8788 25.1936 44.6474 26.4875Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.79296875 10.8515625)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.36109 0L0 12.7763C0.510644 14.6471 1.25631 16.4204 2.205 18.0634L2.97369 18.0634L3.88837 13.1152L8.44163 13.1152C13.9858 13.1152 15.4763 8.13771 15.8336 5.69294C16.1917 3.24914 14.4037 0 10.6475 0L2.36109 0ZM7.48011 10.3132L4.40631 10.3132L5.78021 2.87719L8.90912 2.87719C11.959 2.87719 12.0526 4.71947 11.8497 6.10524C11.6467 7.4911 10.6227 10.3132 7.48011 10.3132Z",
  transform: "translate(0 4.814453)",
  id: "Vector",
  fill: "#0F0A39",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6247 0L3.33826 0L0 18.0635L3.95077 18.0635L4.86545 13.1153L9.41871 13.1153C11.8846 13.1153 13.5486 12.1308 14.6662 10.8221C14.8978 9.52813 15.019 8.19554 15.019 6.83455C15.019 4.66444 14.7114 2.56597 14.1383 0.580429C13.4339 0.216737 12.5945 0 11.6247 0ZM8.45631 10.3133L5.38347 10.3133L6.75738 2.87727L9.88629 2.87727C12.9362 2.87727 13.0298 4.71955 12.8268 6.10532C12.6239 7.49118 11.5999 10.3133 8.45631 10.3133Z",
  transform: "translate(29.1875 4.814453)",
  id: "Vector",
  fill: "#0F0A39",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.37215 4.87363L7.27286 0L3.33835 0L0 18.0629L3.93451 18.0629L5.8543 7.67549C6.56358 7.67549 7.50576 7.67549 8.36885 7.67549C10.038 7.67549 11.1707 8.03321 10.9322 9.58316C10.6937 11.1331 9.32264 17.9887 9.32264 17.9887L13.3167 17.9887C13.3167 17.9887 14.8667 10.3582 15.1051 8.21198C15.3437 6.06586 13.3764 4.87363 11.1707 4.87363C9.56275 4.87363 7.41743 4.87363 6.37215 4.87363Z",
  transform: "translate(15.214844 0)",
  id: "Vector",
  fill: "#0F0A39",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgPhp = function SvgPhp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/php.a3b5653f.svg";
export { ForwardRef as ReactComponent };